import React from 'react';
import cssLang from 'react-syntax-highlighter/dist/languages/hljs/css';
import objectiveCLang from 'react-syntax-highlighter/dist/languages/hljs/objectivec';
import swiftLang from 'react-syntax-highlighter/dist/languages/hljs/swift';
import xmlLang from 'react-syntax-highlighter/dist/languages/hljs/xml';
import SyntaxHighlighter, { registerLanguage, } from 'react-syntax-highlighter/dist/light';
import { CopyToClipboard, SpecsPanel } from '@marvelapp/ui-internal';
import * as codeConstants from '../../constants/code';
import highlighterStyle from '../../constants/highlighterStyle';
import * as APIRequestStatus from '../../constants/requestStatus';
import CodeError from './CodeError';
import PanelBox from './PanelBox';
registerLanguage('css', cssLang);
registerLanguage('objectivec', objectiveCLang);
registerLanguage('swift', swiftLang);
registerLanguage('xml', xmlLang);
export default function PanelCode(_a) {
    var code = _a.code, requestStatus = _a.requestStatus, currentLang = _a.currentLang;
    var hasError = requestStatus[currentLang] === APIRequestStatus.ERROR;
    return (React.createElement(SpecsPanel, { renderLink: function () { return (React.createElement(CopyToClipboard, { bg: "transparent", btnText: "Copy code", color: "marvelDark", fontWeight: 400, px: 0, text: !hasError ? code[currentLang] : undefined })); }, title: codeConstants.LABELS[currentLang] }, !hasError ? (React.createElement(PanelBox, null,
        React.createElement(SyntaxHighlighter, { codeTagProps: { className: 'codeBlock' }, language: currentLang === 'android' ? 'xml' : currentLang, lineStyle: { whiteSpace: 'pre' }, PreTag: "span", style: highlighterStyle, wrapLines: true }, code[currentLang]))) : (React.createElement(PanelBox, null,
        React.createElement(CodeError, { lang: currentLang })))));
}
